<template>
    <b-modal
        :hide-header="true"
        :hide-footer="true"
        :ok-only="true"
        :id="id"
    >
        <Paragraph class="pt-2 mb-0 font-bold text-xl"> {{ $t(text) }}</Paragraph>
        <!-- Modal body -->

        <HrRow/>

        <div class="modal-body">
            <RowColumn :is-row-margin-top="false">
                <FormTag>
                    <div class="row">
                        <b-form-input v-model="name" class="border-gray-300 focus:ring-0 h-11" />
                    </div>
                </FormTag>
            </RowColumn>
        </div>
        <HrRow/>

        <RowColumn>

            <div class="d-flex">
                <div class="col-12 col-md-6 col-xl-6 mt-4">
                    <SubmitRow
                        text="save"
                        sm-size="12"
                        md-size="12"
                        :is-disabled="false"
                        :do-action="createScale"
                        :is-loading="isLoading"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-6 mt-4">
                    <b-button
                        class="w-100 h-10"
                        variant="secondary"
                        @click="hideModal"
                    >
                        {{ $t('goBack') }}
                    </b-button>
                </div>
            </div>

        </RowColumn>

    </b-modal>

</template>

<script>
import Paragraph from "@/components/html/Paragraph";
import RowColumn from "@/components/RowColumn";
import FormTag from "@/components/html/FormTag";
import validatorMixin from "@/mixin/validatorMixin";
import accessMixin from "@/mixin/accessMixin";
import {mapActions, mapGetters} from "vuex";
import HrRow from "@/components/html/HrRow.vue";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import SubmitRow from "@/components/SubmitRow.vue";

export default {
    name: "ModalPushScale",
    components: {
        HrRow,
        Paragraph,
        RowColumn,
        FormTag,
        SubmitRow,
    },
    mixins: [validatorMixin, accessMixin, dateFormattingMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            isLoading: false,
            orderForm: {
                dateFrom: null,
                dateTo: null,
            },
            name: 'scale_'
        }
    },
    computed: {
        ...mapGetters([]),
    },
    methods: {
        ...mapActions(['pushScale', 'fetchScales']),
        createScale() {
            this.$root.showOverlay = true
            this
                .pushScale({name: this.name})
                .then(() => {
                    this
                        .fetchScales({page: 1})
                        .then(() => {
                            this.$bvModal.hide('scale')
                            this.$root.showOverlay = false
                        })
                })
        },
        hideModal() {
            this.$bvModal.hide('scale')
        },
        generateScaleName() {
            let date = new Date()
            this.name += this.dateTimeFormat(date)
        },
        dateTimeFormat(plainVal) {
            let date = new Date(plainVal);

            if (isNaN(date.getDay())) {
                return
            }

            return  '' +
                date.getFullYear() +
                this.addZero(date.getMonth() + 1) +
                this.addZero(date.getDate()) + '' +
                this.addZero(date.getHours()) + '' +
                this.addZero(date.getMinutes()) + '' +
                this.addZero(date.getSeconds())
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        }
    },
    mounted() {
        this.generateScaleName()
    }

}
</script>

<style scoped>

.subtitle {
    color: #7E7E7E;
}

.subtitle_result {
    font-weight: 600;
}
</style>
